import Default from '@pages/search'

export default {
  path: 'search',
  name: 'search',
  components: {
    default: Default,
  },
}